import {forkJoin, Observable, of, retryWhen} from 'rxjs';
import {Injectable} from '@angular/core';
import {api, retryStrategy} from "../shared/api-loaders";
import { HttpClient, HttpEvent, HttpHeaders, HttpRequest } from "@angular/common/http";
import { GroupAssignmentStatus } from './models/GroupAssignmentStatus';


@Injectable()
export class MfaService {

  constructor(private _http: HttpClient) {
  }

  getBulkUpdateProcessStatus() {
    return this._http.get<GroupAssignmentStatus>(api.bulkUpdateProcessStatus())
      .pipe(retryWhen(retryStrategy()));
  }

  downloadMfaBulkUpdateTemplate() {
    var headers = new HttpHeaders();
    headers = headers.append("Accept", "application/octet-stream");
    const req = new HttpRequest('GET', api.downloadMfaBulkUpdateTemplate(), {
      headers: headers,
      responseType: 'blob',
      observe: 'response',
      reportProgress: true,
    });
    return this._http.request(req);
  }

  uploadBulkUpdateCsv(selectedFile: File): Observable<HttpEvent<any>> {
    const formData: FormData = new FormData();
    formData.append('mfaBulkUpdateCsv', selectedFile);
    const req = new HttpRequest('POST', api.uploadMfaBulkUpdate(), formData, {
      reportProgress: true,
      //responseType: 'json'
    });
    return this._http.request(req);
  }
}

